/**
 * Align an image layer on the canvas (same modes as main-object align).
 * @returns {{ x: number, y: number } | null}
 */
export function alignImageLayer(layer, canvasSize, mode) {
  if (!layer || !canvasSize?.width || !canvasSize?.height) return null;
  const w = Math.max(1, Number(layer.width) || 1);
  const h = Math.max(1, Number(layer.height) || 1);
  const cw = canvasSize.width;
  const ch = canvasSize.height;
  let x = Number(layer.x) || 0;
  let y = Number(layer.y) || 0;

  switch (mode) {
    case "middle":
      x = (cw - w) / 2;
      break;
    case "center":
      y = (ch - h) / 2;
      break;
    case "left":
      x = 0;
      break;
    case "right":
      x = cw - w;
      break;
    case "top":
      y = 0;
      break;
    case "bottom":
      y = ch - h;
      break;
    case "topLeft":
      x = 0;
      y = 0;
      break;
    case "topRight":
      x = cw - w;
      y = 0;
      break;
    case "bottomLeft":
      x = 0;
      y = ch - h;
      break;
    case "bottomRight":
      x = cw - w;
      y = ch - h;
      break;
    default:
      return null;
  }

  return { x: Math.round(x), y: Math.round(y) };
}
